import compact from 'lodash/compact';
import get from 'lodash/get';
import { call, put, select } from 'redux-saga/effects';

import { isBackstageAlbumPath } from '../../../../lib/RouteUtils/BackstageRouteUtils';
import { annotateObjectsForBackstage, mutateBackstageData } from '../../actions';
import { BackstageConstants, emptyMap, Keys } from '../../constants';
import * as D from '../../deps';
import { isBackstagePathUsingGraphQL } from '../../utils';

const { getInDomain, isRequestInFlight, ApiEndpoints } = D;

export function* getCatalogDetailsForBackstageWorker({
  // @ts-expect-error TS(7031) FIXME: Binding element 'pandoraId' implicitly has an 'any... Remove this comment to see the full error message
  payload: { pandoraId, redirectOnNotFound, withCollaborations },
}) {
  yield call(retrieveCatalogDetailsIfNecessary, pandoraId, redirectOnNotFound, withCollaborations);
}

// @ts-expect-error TS(7006) FIXME: Parameter 'pandoraIds' implicitly has an 'any' typ... Remove this comment to see the full error message
export function isPandoraIdsInRequest(pandoraIds) {
  // @ts-expect-error TS(7006) FIXME: Parameter 'requestAction' implicitly has an 'any' ... Remove this comment to see the full error message
  return requestAction => {
    const requestPandoraId =
      requestAction &&
      requestAction.action &&
      requestAction.action.request &&
      requestAction.action.request.content &&
      requestAction.action.request.content.pandoraId;
    if (!requestPandoraId || !pandoraIds || pandoraIds.length === 0) {
      return false;
    }
    return pandoraIds.indexOf(requestPandoraId) > -1;
  };
}

// @ts-expect-error TS(7006) FIXME: Parameter 'pandoraId' implicitly has an 'any' type... Remove this comment to see the full error message
export function* retrieveAnnotationsIfNecessary(pandoraId) {
  if (!pandoraId) {
    return undefined;
  }

  // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const annotations = yield select(getInDomain('catalog.utils.getAnnotations'), pandoraId);

  if (annotations.isEmpty()) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const checker = yield call(isPandoraIdsInRequest, [pandoraId]);
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const isInFlight = yield select(isRequestInFlight, {
      endpoint: ApiEndpoints.CATALOG_ANNOTATE_OBJECTS_SIMPLE,
      checker,
    });

    if (!isInFlight) {
      yield put(getInDomain('catalog.actions.annotateObjectsSimple')([pandoraId]));
    }
  }
}

export function* retrieveCatalogDetailsIfNecessary(
  // @ts-expect-error TS(7006) FIXME: Parameter 'pandoraId' implicitly has an 'any' type... Remove this comment to see the full error message
  pandoraId,
  redirectOnNotFound = false,
  withCollaborations = false,
) {
  if (!pandoraId) {
    return undefined;
  }

  // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const catalogDetails = yield select(
    getInDomain('catalog.utils.getCatalogDetailsFromState'),
    pandoraId,
  );
  if (catalogDetails.isEmpty()) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const checker = yield call(isPandoraIdsInRequest, [pandoraId]);
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const isInFlight = yield select(isRequestInFlight, {
      endpoint: withCollaborations
        ? ApiEndpoints.CATALOG_GET_DETAILS_WITH_COLLABORATIONS
        : ApiEndpoints.CATALOG_GET_DETAILS,
      checker,
    });

    if (!isInFlight) {
      yield put(
        getInDomain('catalog.actions.getDetails')(
          pandoraId,
          redirectOnNotFound,
          withCollaborations,
        ),
      );
    }
  }
}

// @ts-expect-error TS(7031) FIXME: Binding element 'artistPandoraId' implicitly has a... Remove this comment to see the full error message
export function* getArtistEventsForBackstageWorker({ payload: { artistPandoraId } }) {
  if (artistPandoraId) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const events = yield select(
      getInDomain('catalog.utils.getArtistEventsFromState'),
      artistPandoraId,
    );
    if (events.isEmpty()) {
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const checker = yield call(isPandoraIdsInRequest, [artistPandoraId]);
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const isInFlight = yield select(isRequestInFlight, {
        endpoint: ApiEndpoints.GET_ARTIST_EVENTS,
        checker,
      });
      if (!isInFlight) {
        yield put(getInDomain('catalog.actions.getArtistEvents')(artistPandoraId));
      }
    }
  }
}

export function* getArtistDiscographyForBackstageWorker({
  // @ts-expect-error TS(7031) FIXME: Binding element 'artistPandoraId' implicitly has a... Remove this comment to see the full error message
  payload: { artistPandoraId, withCollaborations },
}) {
  if (artistPandoraId) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const artistDiscography = yield select(
      getInDomain('catalog.utils.getArtistDiscographyFromState'),
      artistPandoraId,
    );
    if (artistDiscography.isEmpty()) {
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const checker = yield call(isPandoraIdsInRequest, [artistPandoraId]);
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const isInFlight = yield select(isRequestInFlight, {
        endpoint: withCollaborations
          ? ApiEndpoints.CATALOG_GET_ARTIST_DISCOGRAPHY_WITH_COLLABORATIONS
          : ApiEndpoints.CATALOG_GET_ARTIST_DISCOGRAPHY,
        checker,
      });

      if (!isInFlight) {
        yield put(
          getInDomain('catalog.actions.getArtistDiscography')(
            artistPandoraId,
            0,
            withCollaborations,
          ),
        );
      }
    }
  }
}

// @ts-expect-error TS(7031) FIXME: Binding element 'albumIds' implicitly has an 'any'... Remove this comment to see the full error message
export function* getArtistDiscographyAnnotationsWorker({ payload: { albumIds } }) {
  const DISCOGRAPHY_ANNOTATION_LIMIT = 50;
  let offset = 0;
  while (offset < albumIds.size) {
    const subList = albumIds.slice(offset, offset + DISCOGRAPHY_ANNOTATION_LIMIT);
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const idsOfMissingAnnotations = yield select(
      getInDomain('catalog.utils.getIdsOfMissingAnnotations'),
      subList,
    );
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const pathname = yield select(D.getCurrentPathnameFromState);
    const isAllDiscographyPath = D.Utils.Route.isBackstageArtistAllAlbumsPath(pathname);

    if (idsOfMissingAnnotations.size && isAllDiscographyPath) {
      yield call(
        D.putAndWait,
        getInDomain('catalog.actions.annotateObjectsSimple')(idsOfMissingAnnotations),
      );
    }

    offset += DISCOGRAPHY_ANNOTATION_LIMIT;
  }
}

export function* getAllArtistTracksForBackstageWorker({
  // @ts-expect-error TS(7031) FIXME: Binding element 'artistPandoraId' implicitly has a... Remove this comment to see the full error message
  payload: { artistPandoraId, withCollaborations },
}) {
  if (artistPandoraId) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const artistTracks = yield select(
      getInDomain('catalog.utils.getAllArtistTracksFromState'),
      artistPandoraId,
    );
    if (artistTracks.isEmpty()) {
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const checker = yield call(isPandoraIdsInRequest, [artistPandoraId]);
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const isInFlight = yield select(isRequestInFlight, {
        endpoint: withCollaborations
          ? ApiEndpoints.CATALOG_GET_ALL_ARTIST_TRACKS_WITH_COLLABORATIONS
          : ApiEndpoints.CATALOG_GET_ALL_ARTIST_TRACKS,
        checker,
      });
      if (!isInFlight) {
        yield put(
          getInDomain('catalog.actions.getAllArtistTracks')(artistPandoraId, 0, withCollaborations),
        );
      }
    }
  }
}

// @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
export function* handleAllArtistTracksForBackstageAnnotationsWorker(action) {
  const pandoraIds = get(action, 'response.tracks', []).slice(
    0,
    BackstageConstants.NUM_ITEMS_PER_PAGE_ARTIST_ALL_TRACKS,
  );
  yield put(annotateObjectsForBackstage(pandoraIds));
}

export function* annotateObjectsForBackstageWorker({
  // @ts-expect-error TS(7031) FIXME: Binding element 'pandoraIds' implicitly has an 'an... Remove this comment to see the full error message
  payload: { pandoraIds, useAnnotateObjects },
}) {
  if (pandoraIds) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const idsOfMissingAnnotations = yield select(
      getInDomain('catalog.utils.getIdsOfMissingAnnotations'),
      pandoraIds,
    );
    if (idsOfMissingAnnotations.size > 0) {
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const checker = yield call(isPandoraIdsInRequest, idsOfMissingAnnotations.toJS());
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const isInFlight = yield select(isRequestInFlight, {
        endpoint: useAnnotateObjects
          ? ApiEndpoints.CATALOG_ANNOTATE_OBJECTS
          : ApiEndpoints.CATALOG_ANNOTATE_OBJECTS_SIMPLE,
        checker,
      });

      if (!isInFlight) {
        if (useAnnotateObjects) {
          yield put(D.annotateIds(idsOfMissingAnnotations, false));
        } else {
          yield put(getInDomain('catalog.actions.annotateObjectsSimple')(idsOfMissingAnnotations));
        }
      }
    }
  }
}

// @ts-expect-error TS(7031) FIXME: Binding element 'pandoraIds' implicitly has an 'an... Remove this comment to see the full error message
export function* annotateObjectsForBackstageArtistAllSongsWorker({ payload: { pandoraIds } }) {
  if (pandoraIds) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const idsOfMissingAnnotations = yield select(
      getInDomain('catalog.utils.getIdsOfMissingAnnotations', emptyMap),
      pandoraIds,
    );
    if (idsOfMissingAnnotations.size > 0) {
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const checker = yield call(isPandoraIdsInRequest, idsOfMissingAnnotations.toJS());
      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      const isInFlight = yield select(isRequestInFlight, {
        endpoint: ApiEndpoints.CATALOG_ANNOTATE_OBJECTS_SIMPLE,
        checker,
      });

      if (!isInFlight) {
        yield call(
          D.putAndWait,
          getInDomain('catalog.actions.annotateObjectsSimple')(idsOfMissingAnnotations),
        );

        // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
        const albumIds = yield select(
          getInDomain('catalog.utils.getAlbumIdsFromTrackIds'),
          idsOfMissingAnnotations,
        );
        yield put(annotateObjectsForBackstage(albumIds));
      }
    }
  }
}

// @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
export function* interceptBackstageNavigation(action) {
  const pathname = get(action, 'payload.pathname', '');
  // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const isBackstagePageUsingGraphQL = yield select(isBackstagePathUsingGraphQL, pathname);

  if (!isBackstagePageUsingGraphQL) {
    const pandoraId = get(action, 'payload.state.pandoraId', null);
    yield call(retrieveCatalogDetailsIfNecessary, pandoraId);
    yield call(retrieveAnnotationsIfNecessary, pandoraId);
  }
}

// @ts-expect-error TS(7031) FIXME: Binding element 'payload' implicitly has an 'any' ... Remove this comment to see the full error message
export function* onEnterBackstage({ payload }) {
  const { pathname } = payload.location;

  if (isBackstageAlbumPath(pathname)) {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    let annotation = yield select(
      D.getInDomain('catalog.utils.getAnnotationByShareableUrlPath'),
      pathname,
    );

    if (annotation.isEmpty()) {
      const { seoToken3: encryptedPandoraId } = payload.params;

      yield call(
        D.putAndWait,
        D.getInDomain('catalog.actions.annotateObjectsSimple')([encryptedPandoraId]),
      );

      // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      annotation = yield select(
        D.getInDomain('catalog.utils.getAnnotationByShareableUrlPath'),
        pathname,
      );
    }

    const { pandoraId, type: pandoraType } = annotation.toJS();

    yield put(mutateBackstageData({ [Keys.CURRENT_ROUTE]: { pandoraId, pandoraType } }));
    yield call(retrieveCatalogDetailsIfNecessary, pandoraId);
  }
}

// @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
export function* fetchGenreCurators(action) {
  const genres = get(action, 'response.entities.genres', {});
  const genrePandoraIds = Object.values(genres)
    .map(genre => get(genre, 'pandoraId', null))
    .filter(pandoraId => !!pandoraId);

  const requestParams = D.GraphQL.Queries.getGenreCurators({
    pandoraIds: compact(genrePandoraIds),
  });
  yield call(D.Services.GraphQL.graphQLRequest(requestParams));
}

// @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
export function* fetchPlaylistCurator(action) {
  const playlist = get(action, 'response.result');
  if (playlist) {
    const requestParams = D.GraphQL.Queries.getPlaylistCurators({
      pandoraIds: [playlist],
    });
    yield call(D.Services.GraphQL.graphQLRequest(requestParams));
  }
}
